import { getCurrentDate } from '@/api/commons'
import * as Utils from '@/utils/index'

const state = {
  currentDate: null,
  selectedClient: null,
  selectedConsult: null,
  selectedShared: null,
  selectedInvoice: null,
  selectedTransfer: null,
  mName :null,
}

const mutations = {
  setCurrentDate: (state, currentDate) => {
    state.currentDate = currentDate
  },
  setSelectedClient: (state, selectedClient) => {
    state.selectedClient = selectedClient
  },
  setSelectedConsult: (state, selectedConsult) => {
    state.selectedConsult = selectedConsult
  },
  setSelectedShared: (state, selectedShared) => {
    state.selectedShared = selectedShared
  },
  setSelectedInvoice: (state, selectedInvoice) => {
    state.selectedInvoice = selectedInvoice
  },
  setSelectedTransfer: (state, selectedTransfer) => {
    state.selectedTransfer = selectedTransfer
  },
  setMName: (state, mName) => {
    state.mName = mName
  },
}

const actions = {
  initCurrentDate({ dispatch, commit }) {
    return new Promise(async(resolve, reject) => {
      getCurrentDate({
        dept_id: 1 // 默认取北京春雪部门ID
      }).then(resp => {
        if (resp.obj && resp.obj.curr_date) {
          commit('setCurrentDate', resp.obj.curr_date)
          dispatch('tip/add', { key: Utils.createUniqueString(), name: '初始化当前账期成功.' }, { root: true })
          resolve()
        } else {
          reject('初始化当前账期失败')
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  setMnName({ commit }, mName) {
    commit('setMName', mName)
  },
  setSelectedClient({ commit }, selectedClient) {
    commit('setSelectedClient', selectedClient)
  },
  setSelectedConsult({ commit }, selectedConsult) {
    commit('setSelectedConsult', selectedConsult)
  },
  setSelectedShared({ commit }, selectedShared) {
    commit('setSelectedShared', selectedShared)
  },
  setSelectedInvoice({ commit }, selectedInvoice) {
    commit('setSelectedInvoice', selectedInvoice)
  },
  setSelectedTransfer({ commit }, selectedTransfer) {
    commit('setSelectedTransfer', selectedTransfer)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js